import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FBoxContainer } from '../../../../../../../components/base';
import { FORTA_BLUE } from '../../../../../../../utils/colors';
import CheckIconLabel from '../checkIconLabel/CheckIconLabel';
import { getClientSignsSymptomsData } from '../../../../constants';

import type { ISignsAndSymptomsObserved } from '../../../../../../../utils/types';

interface ISymptomsReadOnlyProps {
  signsAndSymptomsObserved?: ISignsAndSymptomsObserved;
}

function SymptomsReadOnly({ signsAndSymptomsObserved }: ISymptomsReadOnlyProps) {
  const { t } = useTranslation('sessionNotes');
  return signsAndSymptomsObserved ? (
    <FBoxContainer
      sx={{
        my: 3,
        position: 'relative',
        borderRadius: '10px',
        boxShadow: 'none',
      }}
      contentStyle={{
        pt: 2.5,
      }}
    >
      <Typography fontSize={21} color={FORTA_BLUE.primary} textAlign="left">
        {t('symptomsObserved.title')}
      </Typography>
      <Grid container sx={{ flexFlow: 1, mt: 1 }}>
        <Grid
          item
          sx={{
            borderRight: `1px solid ${FORTA_BLUE.light2}`,
            borderRightWidth: { xs: 0, md: '1px' },
          }}
          pr={{
            md: 2,
            xs: 0,
          }}
          md={4}
          xs={12}
        >
          {getClientSignsSymptomsData(t)
            .filter((item) => item.columnNumber === 1)
            .map((item) => (
              <CheckIconLabel
                checked={Boolean(
                  signsAndSymptomsObserved[item.id],
                )}
                label={item.label}
                key={item.id}
                tooltipContent={item.description}
              />
            ))}
        </Grid>
        <Grid
          item
          sx={{
            borderRight: `1px solid ${FORTA_BLUE.light2}`,
            borderRightWidth: { xs: 0, md: '1px' },
          }}
          px={{
            md: 2,
            xs: 0,
          }}
          md={4}
          xs={12}
        >
          {getClientSignsSymptomsData(t)
            .filter((item) => item.columnNumber === 2)
            .map((item) =>
              item.id === 'restricted_repetitive_behaviors' &&
              signsAndSymptomsObserved.restricted_receptive_behaviors !== null ? (
                <CheckIconLabel
                  checked={Boolean(signsAndSymptomsObserved.restricted_receptive_behaviors)}
                  label={t('symptomsObserved.fields.restrictedReceptiveBehaviors')}
                  key={'restricted_receptive_behaviors'}
                />
              ) : (
                <CheckIconLabel
                  checked={Boolean(
                    signsAndSymptomsObserved[item.id],
                  )}
                  label={item.label}
                  key={item.id}
                  tooltipContent={item.description}
                />
              ),
            )}
        </Grid>
        <Grid
          item
          md={4}
          xs={12}
          pl={{
            md: 2,
            xs: 0,
          }}
        >
          {getClientSignsSymptomsData(t)
            .filter((item) => item.columnNumber === 3)
            .map((item) => (
              <CheckIconLabel
                checked={Boolean(
                  signsAndSymptomsObserved[item.id],
                )}
                label={item.label}
                key={item.id}
                tooltipContent={item.description}
              />
            ))}
          <CheckIconLabel
            label={`${t('symptomsObserved.fields.other')}: ${
              signsAndSymptomsObserved.other ? signsAndSymptomsObserved.other : 'N/A'
            }`}
            key={'other'}
            checked={Boolean(signsAndSymptomsObserved.other)}
          />
        </Grid>
      </Grid>
    </FBoxContainer>
  ) : null;
}

export default SymptomsReadOnly;
